import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from '@store/index';
import App from './portfoliov1/App';
import Appv2 from './Appv2';
import './styles/index.css';
// Check URL params to determine which version to render
// Always default to v2 for SSG consistency
const getAppVersion = () => {
    if (typeof window === 'undefined')
        return 'v2'; // SSG safety check
    try {
        const params = new URLSearchParams(window.location.search);
        return params.get('version') === 'v1' ? 'v1' : 'v2';
    }
    catch {
        return 'v2'; // Fallback to v2
    }
};
const rootElement = typeof document !== 'undefined' ? document.getElementById('root') : null;
// For SSG, always use v2. For client, check URL params
const version = typeof window !== 'undefined' ? getAppVersion() : 'v2';
const SelectedApp = version === 'v2' ? Appv2 : App;
if (rootElement && rootElement.hasChildNodes()) {
    // Hydrate if HTML is pre-rendered (SSG output)
    ReactDOM.hydrateRoot(rootElement, _jsx(React.StrictMode, { children: _jsx(Provider, { store: store, children: _jsx(SelectedApp, {}) }) }));
}
else {
    // Client-side render (fallback for dev or if SSG failed)
    const root = ReactDOM.createRoot(rootElement);
    root.render(_jsx(React.StrictMode, { children: _jsx(Provider, { store: store, children: _jsx(SelectedApp, {}) }) }));
}
